import React from 'react';
import { MapPin, Mail, Clock, Truck, Phone } from 'lucide-react';
import SEO from '../components/SEO';
import ContactForm from '../components/ContactForm';
import './Contacto.css';

const Contacto = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contacto - Artelaser3D",
    "description": "Contacta con Artelaser3D. Estamos en Asturias y ofrecemos envíos a toda España. Responde en menos de 24 horas.",
    "url": "https://artelaser3d.es/contacto",
    "mainEntity": {
      "@type": "Organization",
      "name": "Artelaser3D",
      "url": "https://artelaser3d.es",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Asturias",
        "addressCountry": "ES"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+34-632-393-838",
        "contactType": "customer service",
        "availableLanguage": ["Spanish"],
        "areaServed": "ES"
      }
    }
  };

  return (
    <>
      <SEO 
        title="Contacto"
        description="Contacta con Artelaser3D. Estamos en Asturias y ofrecemos envíos a toda España. Responde en menos de 24 horas. Teléfonos: 632 39 38 38 (Láser) y 646 37 16 48 (Impresión 3D)"
        keywords="contacto Artelaser3D, teléfono grabado láser Asturias, contacto impresión 3D Asturias, contactar empresa láser Oviedo"
        canonicalUrl="https://artelaser3d.es/contacto"
        schema={schema}
      />

      <div className="page-header">
        <div className="container">
          <span className="badge">Contacto</span>
          <h1>Hablemos de tu <span className="text-accent">proyecto</span></h1>
          <p>Estamos aquí para ayudarte. Cuéntanos qué necesitas y te responderemos en menos de 24 horas.</p>
        </div>
      </div>

      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info-box">
              <h2>Información de contacto</h2>
              
              <div className="info-item">
                <div className="info-icon-wrapper">
                  <MapPin className="info-icon" size={20} />
                </div>
                <div>
                  <h3>Ubicación</h3>
                  <p>Asturias, España</p>
                  <small>Servicio presencial y online</small>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon-wrapper">
                  <Mail className="info-icon" size={20} />
                </div>
                <div>
                  <h3>Email</h3>
                  <a href="mailto:info@artelaser3d.es">info@artelaser3d.es</a>
                  <small>Respuesta en 24h</small>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon-wrapper">
                  <Phone className="info-icon" size={20} />
                </div>
                <div>
                  <h3>Teléfono / WhatsApp</h3>
                  <a href="tel:632393838">632 39 38 38</a>
                  <small>Grabado Láser - Antonio</small>
                  <br />
                  <a href="tel:646371648">646 37 16 48</a>
                  <small>Impresión 3D - Pablo</small>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon-wrapper">
                  <Clock className="info-icon" size={20} />
                </div>
                <div>
                  <h3>Horario</h3>
                  <p>Lunes a Viernes</p>
                  <small>9:00 - 18:00</small>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon-wrapper">
                  <Truck className="info-icon" size={20} />
                </div>
                <div>
                  <h3>Envíos</h3>
                  <p>A toda España</p>
                  <small>Envíos urgentes disponibles</small>
                </div>
              </div>


            </div>

            <div className="contact-form-box">
              <h2>Envíanos un mensaje</h2>
              <p>Completa el formulario y nos pondremos en contacto contigo.</p>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contacto;
